'use client';
import './style.sass';

import React from 'react';

import { listPath, listTitle } from './constants';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import About from '../reusable-components/layouts-components__fondrt/about';
import AboutUs from '../reusable-components/layouts-components__fondrt/about-us';
import Description from '../reusable-components/layouts-components__fondrt/description';
import Plan from '../reusable-components/layouts-components__fondrt/plan';
import Problem from '../reusable-components/layouts-components__fondrt/problem';
import Process from '../reusable-components/layouts-components__fondrt/process';
import Task from '../reusable-components/layouts-components__fondrt/task';
import Team from '../reusable-components/layouts-components__fondrt/team';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TitleCase from '../../case-components/title-case';

const nextProjectGens = {
    marketing: true,
    nextProjectTitle:
        'Кейс по маркетингу «Дети в Сколково». Как продвигать сообщество во «ВКонтакте»',
    nextProjectImg: '/images/pic/skolkovo-kids/main.png',
    nextProjectLink: '/cases/marketing/skolkovo-kids',
    nextProjectLinkTitle: 'Фармацевтика',
    nextProjectText:
        'Мы расскажем, как сделать сообщество эффективной площадкой для бренда, найти и вовлечь в коммуникацию узкую аудиторию и за счет каких инструментов можно удержать юных инноваторов, их родителей и учителей в одном паблике.',
};

const FondRT = () => {
    return (
        <section>
            <TitleCase
                img="/images/pic/new-fondrt/banner.jpg"
                listPath={listPath}
                listTitle={listTitle}
                caseName="frt"
            />
            <Description />
            <Task />
            <Problem />
            <About />
            <Process />
            <Plan />

            <ScrollAnimation className="fontrt-about__us">
                <AboutUs />
            </ScrollAnimation>

            <Team />

            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>

            <NextProject NextProject={nextProjectGens} />
        </section>
    );
};

export default FondRT;
